import axios from 'axios';
import { SUCCESS_STATUS_CODE } from '@superdata/basic-data-service';
import { STATUS, LoginServiceParams, LoginFields } from '../types';
import { AuthService } from '..';
// import { afterSuccess } from '../auth';

export default class LoginService implements LoginServiceParams {
  constructor({ url, fields, contentType = 'application/json' }: LoginServiceParams) {
    this.url = url;
    this.fields = fields;
    this.contentType = contentType;
  }
  url: string;
  fields: LoginFields;
  contentType?: string;
  parent?: AuthService;
  // TODO: 动态类型校验
  async login(params: any) {
    // fields + params => 请求数据
    const payload: any = Object.keys(this.fields).reduce((result, key) => {
      result[this.fields[key]] = params[key];
      delete params[key];
      return result;
    }, {});
    const { data } = await axios.post(`${this.url}`, {
      ...payload,
      ...params,
      isPlatformLog: true,
    }, {
      headers: {
        'Content-Type': this.contentType,
      },
    });
    // 触发单IP登录
    if (data.code === 100013) {
      return { status: STATUS.FORCE, token: data.data.token };
    }
    // 强制修改密码
    if (data.code === 100019) {
      return { status: STATUS.MODIFY };
    }
    if (data.code === SUCCESS_STATUS_CODE) {
      return this.parent?.afterSuccess(data.data);
    }
    return { status: STATUS.FAILED, message: data.message, code: data.code };
  }
}